'use strict';
var globalThis = require('../internals/global-this');

module.exports = function (CONSTRUCTOR, METHOD) {
  var Constructor = globalThis[CONSTRUCTOR];
  var Prototype = Constructor && Constructor.prototype;
  return Prototype && Prototype[METHOD];
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/get-built-in-prototype-method.js
// module id = 334
// module chunks = 113